// Formatting helpers for equipment drawing metadata (size · date).

export const formatDrawingSize = (kb) => {
  const n = parseFloat(kb);
  if (!n || Number.isNaN(n)) return "";
  if (n >= 1024) return `${(n / 1024).toFixed(1)} MB`;
  return `${Math.round(n)} KB`;
};

export const formatDrawingDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// "2.3 MB · 08 Jun 2026"
export const formatDrawingMeta = (file) =>
  [formatDrawingSize(file?.file_size_kb), formatDrawingDate(file?.created_at)]
    .filter(Boolean)
    .join(" · ");
